import React from "react";
import { useTable, usePagination } from "react-table";

import BTable from 'react-bootstrap/Table';

import { CDatePicker } from "@coreui/react-pro";
import '@coreui/coreui-pro/dist/css/coreui.min.css'


export default function PaginationTable({
  columns,
  data,
  fetchData,
  loading,
  total,
  pageCount: controlledPageCount,
}) {
  // Use the useTable Hook to send the columns and data to build the table
  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    page, // fetch the current page
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    setPageSize,
    prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      manualPagination: true,
      pageCount: controlledPageCount,
    },
    usePagination
  );

  const [number, setNumber] = React.useState('');
  const [bidding, setBidding] = React.useState('');


  function update() {
    fetchData({ pageIndex, pageSize, number, bidding, });
  }

  React.useEffect(() => {
    fetchData({ pageIndex, pageSize, number, bidding, });
  }, [pageIndex, pageSize, number, bidding,])

  function handleNumberChange(event) {
    gotoPage(0);
    setNumber(event.target.value);
  }

  function handleBiddingChange(date) {
    gotoPage(0);
    setBidding(date.toLocaleDateString("ru-RU"));
  }

  function cleanFilters() {
    gotoPage(0);
    setNumber('');
    setBidding('');

    const bidInput = document.getElementById('bidding-input').getElementsByTagName('input')[0];
    bidInput.value = ''
  }

  return (
    <div className="m-3">
      <div className="row mb-3">
        <div className="col-2">
          <input
            className="form-control"
            placeholder="Номер лота"
            value={number}
            onChange={handleNumberChange}
          />
        </div>

        <div className="col-2">
          <CDatePicker
            id="bidding-input"
            locale="ru-RU"
            inputReadOnly
            cleaner={false}
            onDateChange={handleBiddingChange}
            placeholder="Начало торгов"
          />
        </div>

        <div className="col-2">
          <div className="btn-group w-100">
            <button
              className="btn btn-primary"
              onClick={cleanFilters}
            >Очистить фильтр
            </button>
          </div>
        </div>


      </div>

      <BTable striped bordered hover size="sm" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {

            total
              ? page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })
              : <tr><td colSpan="12">Ничего не найдено</td></tr>

          }
        </tbody>
      </BTable>

      <div className="row">

        <div className="col-3">
          <span>Страница{' '}<strong>{pageIndex + 1} из {pageOptions.length}</strong>,{' '}</span>
          <span>Найдено:{' '}<strong>{total}</strong>{' '}</span>
        </div>

        <div className="col-6">
          <div className="d-flex justify-content-center">
            <div className="btn-group">
              <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="btn btn-primary">{'<<'}</button>{' '}
              <button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-primary">Предыдущая страница{' '}</button>
              <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-primary">Следующая страница{' '}</button>
              <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="btn btn-primary">{'>>'}</button>{' '}
            </div>
          </div>
        </div>

        <div className="col-3">
          <div className="row align-items-center">
            <div className="col-auto ms-auto">
              <span>Перейти на страницу:</span>
            </div>
            <div className="col-auto">
              <input
                className="form-control"
                type="number"
                defaultValue={pageIndex + 1}
                onChange={e => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0
                  gotoPage(page)
                }}
                style={{ width: '100px' }}
              />{' '}
            </div>
            <div className="col-auto">
              <select
                className="form-select"
                value={pageSize}
                onChange={e => { setPageSize(Number(e.target.value)) }}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>{pageSize}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}